import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { UsbPolicyStatCardKey } from './usb-policy-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    todayAccessCount: { default: 0 },
    pendingApprovals: { default: 0 },
    connectedDevices: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emit = __emit

const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const today = props.todayAccessCount ?? 0
  const conn = props.connectedDevices ?? 0
  return [
    {
      label: t('usbPolicy.todayAccessCount'),
      value: today,
      span: 8,
      clickable: today > 0,
      events: {
        click: () => {
          if (today <= 0) return
          emit('statClick', 'todayAccess')
        }
      }
    },
    { label: t('usbPolicy.pendingApprovals'), value: props.pendingApprovals, span: 8, clickable: false },
    {
      label: t('usbPolicy.connectedDevices'),
      value: conn,
      span: 8,
      clickable: conn > 0,
      events: {
        click: () => {
          if (conn <= 0) return
          emit('statClick', 'connectedDevices')
        }
      }
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})